export const INSTRUMENT_CLICKHOUSE_WITH_QRYN = 'INSTRUMENT_CLICKHOUSE_WITH_QRYN'
export const ROTATE_QRYN_KEYS = 'ROTATE_QRYN_KEYS'
export const CREATE_QRYN_TOKEN = 'CREATE_QRYN_TOKEN'
export const DELETE_QRYN_TOKEN = 'DELETE_QRYN_TOKEN'
export const UPDATE_RETENTION_POLICIES = 'UPDATE_RETENTION_POLICIES'
export const UPDATE_FINGERPRINTS_LIMIT = 'UPDATE_FINGERPRINTS_LIMIT'
export const CLEAR_QRYN_CACHE = 'CLEAR_QRYN_CACHE'
export const UPDATE_DRILLDOWN = 'UPDATE_DRILLDOWN'
